import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./App";
import "./i18n";
import store from "./store";
import { initializeErrorHandlers } from "./utils/errorHandler";
import ErrorBoundary from "./components/Common/ErrorBoundary";

// Глобальные обработчики необработанных ошибок/промисов.
initializeErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
);
